import React, {
    Children,
    Fragment,
    useEffect,
    useState
} from 'react';
import styled from "styled-components";
import { useQueryString } from "../custom-hooks/index";
import { landingpageSegments, routeConstants } from "../constants/index";
import {
    InformationRectangle,
    ImageContainer,
    BackgroundColorContainer,
    HeaderAndParagraph,
    IconTextTopDown,
    Accordion,
    Tabs,
    IconTextLeftToRight,
    ButtonOrange,
    Quotes,
    Footer,
    TrustPilotWidgets
} from '../components-shared';
import { loadThirdPartyScript } from "../utils/index";
import nykreditIcons from '../images/icons/Nykredit_Icons.svg';
import { useDispatch } from "react-redux";
import { 
    addQueryString,
    addLocationSearch
} from "../redux/index";
import { useHistory, useLocation } from 'react-router';

const Header = styled.h1`
    margin-left: auto;
    margin-right: auto;
    width: 320px;
    height: 60px;
    font-size: 22px;
    line-height: 30px;
    font-weight: 400;

    ${props => props.theme.mediaQueries.medium}{
        display: none;
    }
`

const HeroWrapper = styled.div`
    margin-bottom: -30px;   

    ${props => props.theme.mediaQueries.medium}{
        margin-top: 38px;
        position: relative;
        margin-left: auto;
        margin-right: auto;
        max-width: 961px;
        width: 100%;
        margin-bottom: -376px;
    }
`

const StyledImageContainer = styled(ImageContainer)`
    ${props => props.theme.mediaQueries.medium}{
        margin-left: 0;
        margin-right: 0;
        height: auto;
        text-align: ${props => props.textAlign || 'center'};
    }
`;

const TabsWrapper = styled.div`

    display: flex;
    flex-direction: column;

`

const FlexboxWrapper = styled.div`
    display: flex;
    flex-direction: column;

    ${props => props.theme.mediaQueries.medium}{
        flex-direction:  ${props => props.flexDirection || 'row'};
        justify-content: ${props => props.justifyContent || 'space-around'};
        flex-wrap: ${props => props.flexWrap || 'nowrap'};
        width: ${props => props.width};
    };
`


const LandingPage = (props) => {
    const [trustPilotIsLoaded, setTrustPilotIsLoaded] = useState(false);
    const dispatch = useDispatch()
    const queryString = useQueryString('utm_campaign');
    const location = useLocation();

    useEffect(() => {
        dispatch(addQueryString(queryString))

        //const locationSearch = sessionStorage.getItem('locationSearch')
        if (location.search) {
            sessionStorage.setItem('locationSearch', location.search)
        }
        
        dispatch(addLocationSearch(location.search))
    }, [])


    useEffect(() => {
        loadThirdPartyScript('TrustPilot', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', () => {
            setTrustPilotIsLoaded(true);
        });
    });

    useEffect(() => {
        loadThirdPartyScript('recaptcha', '//www.google.com/recaptcha/api.js?render=6LdOD7oaAAAAAJykG6pl04WDLNG782Gqks3RcaGl ', () => {
        });
    });
    
    const handelSegmentation = (strings) => {
        let isSegmentation = false
        strings.forEach(string => {
            if (useQueryString('utm_campaign') === string) {
                isSegmentation = true;
            }
        });

        return isSegmentation;
    }

    const renderBackgroundColorContainer = () => {
        const components = [
            {
                backgroundColor: "#FFFFFF",
                padding: "0",
                marginLeft: "0",
                marginRight: "0",
                width: "unset",
                maxWidth: "unset",
                maxWidthMediaQueriesMedium: "none",
                marginTopWrapperMediaQueriesMedium: "77px",
                marginTopWrapper: "70px",
                content: (
                    <HeroWrapper>
                        <StyledImageContainer
                            height="250px"
                            maxWidth="806px"
                            maxHeight='500px'
                            textAlign="unset"
                            imgSrc={landingpageSegments[queryString] && landingpageSegments[queryString].copies.firstImg}
                        />
                        <InformationRectangle
                            background={landingpageSegments[queryString] && (landingpageSegments[queryString].hasOwnProperty('style') && landingpageSegments[queryString].style.heroContainer.background)}
                            top="-64px"
                            topMediaQueriesMedium="-323px"
                            marginRightMediaQueriesMedium='0'
                            headerText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.heroText.header}
                            paragraphText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.heroText.paragraph}
                            charLimit='200'
                            readLessText="Læs mindre"
                            readMoreText="Læs mere"
                            data-aos = "fade-up"                             
                        /> 
                    </HeroWrapper>
                )
            },
            {
                paddingMediaQueriesMedium: "161px 0 56px",
                maxWidthMediaQueriesLarge: "966px",
                transition:"fade-up",
                content: (
                    <Fragment>
                        <h1 style={{ margin: 0 }}>4 gode grunde til at vælge Privatsikring</h1>

                        <FlexboxWrapper
                            justifyContent='space-between'
                            flexWrap='wrap'
                                                         
                        >
                            <IconTextTopDown
                                maxWidthWrapperMediaQueriesMedium="360px"
                                maxWidthMediaQueriesLarge="430px"
                                backgroundImg={`${nykreditIcons}#Sadisfaction`}
                                headerText='Høj kundetilfredshed'
                                paragraphText="Vores kunder er mere end tilfredse. Det kan vi både se på Trustpilot, i vores tilfredshedsanalyser og på det stigende antal kunder, vi får hvert år."
                            />

                            <IconTextTopDown
                                maxWidthWrapperMediaQueriesMedium="360px"
                                maxWidthMediaQueriesLarge="430px"
                                backgroundImg={`${nykreditIcons}#Loop`}
                                headerText='Effektiv skadebehandling'
                                paragraphText="Du kan anmelde skader døgnet rundt, og vi behandler størstedelen af dem indenfor 24 timer. Hele 91% af de kunder, der anmelder en skade hos Privatsikring, er meget tilfredse med skadebehandlingen.."
                            />

                            <IconTextTopDown
                                maxWidthWrapperMediaQueriesMedium="360px"
                                maxWidthMediaQueriesLarge="430px"
                                backgroundImg={`${nykreditIcons}#Bank`}
                                headerText='Anbefalet af banker'
                                paragraphText="Privatsikring har i over 21 år været bankernes foretrukne forsikringspartner. Faktisk anbefaler hele 32 banker deres kunder at vælge vores forsikringer."
                            />
                            <IconTextTopDown
                                maxWidthWrapperMediaQueriesMedium="360px"
                                maxWidthMediaQueriesLarge="430px"
                                backgroundImg={`${nykreditIcons}#Link`}
                                headerText='En del af Codan'
                                paragraphText="Privatsikring er en del af Codan. Det betyder, at alle vores forsikringer er baseret på Codans attraktive forsikringsprodukter."
                            />
                        </FlexboxWrapper>
                    </Fragment>
                )
            },
            {
                backgroundColor: "#FFFFFF",
                content: (
                    <Fragment>
                        {!handelSegmentation([
                            landingpageSegments.boligejer.string,
                            landingpageSegments.pb.string,
                            landingpageSegments.bankkunde.string
                        ]) && <HeaderAndParagraph
                            data-aos = "fade-up"                             
                            headerText="Skift til samme pris og dækning"
                            paragraphText="Er du kunde hos Nykredit Forsikring (Gjensidige) kan du flytte dine forsikringer til Privatsikring og få samme pris og dækning, som du har i dag. På et rådgivningsmøde gennemgår vi, hvad det konkret betyder for dig, og om vi kan tilbyde dig endnu bedre priser og dækninger. Der kan være få tilfælde, hvor pris- og dækningsmatch ikke kan garanteres."
                        />}


                        <HeaderAndParagraph
                            data-aos = "fade-up"                             
                            marginBottomWrapperMediaQueriesMedium="32px"
                            headerText="Flyt på få minutter"
                            paragraphText="Det er nemt at skifte – vi gør stort set alt arbejdet for dig."
                        />


                        <FlexboxWrapper
                            justifyContent="space-between"
                            data-aos="fade-up"
                            width="100%"
                        >
                                <FlexboxWrapper
                                    flexDirection='row'
                                    justifyContent="space-between"
                                    width="335px"
                                >
                                    <HeaderAndParagraph
                                        marginBottomWrapper="24px"
                                        marginBottomWrapperMediaQueriesMedium="24px"
                                        fontSizeH1="1.17rem"
                                        fontSizeH1MediaQueriesMedium="0.7rem"
                                        fontWeightH1="500"
                                        lineHeightH1="22px"
                                        lineHeightH1MediaQueriesMedium="22px"
                                        marginBottomH1="0"
                                        fontSizePMediaQueriesMedium="0.7rem"
                                        lineHeightP="22px"
                                        headerText="Book onlinemøde"
                                        paragraphText="Hold møde med en forsikringsrådgiver og få sammensat dine forsikringer, så de matcher dine behov."
                                    />
                                </FlexboxWrapper>

                                <ButtonOrange
                                    to={routeConstants.ContactModal}
                                    reduxNextPage={routeConstants.BookMeetingModal}
                                    marginBottom="48px"
                                    iconLeft={`${nykreditIcons}#Book_white`}
                                    text="Book møde"
                                    
                                />
                        </FlexboxWrapper>
                    </Fragment>
                )
            },
            handelSegmentation([
                landingpageSegments.boligejer.string,
                landingpageSegments.pb.string,
                landingpageSegments.bankkunde.string
            ]) ? {
                padding: '0px',
                paddingMediaQueriesMedium: '0px',
            } :
            {
                backgroundColor: "#4F525D",
                paddingMediaQueriesMedium: "84px 0 88px",
                content: (
                    <FlexboxWrapper
                        justifyContent="space-between" 
                        flexDirection="column" 
                        data-aos= "fade-up"
                    >
                        <HeaderAndParagraph
                            color="#FFFFFF"
                            fontSizeH1MediaQueriesMedium="1.7rem"
                            lineHeightH1MediaQueriesMedium="30px"
                            fontSizeP="1.17rem"
                            lineHeightP="20px"
                            lineHeightPMediaQueriesMedium="24px"
                            marginBottomH1MediaQueriesMedium="32px"
                            headerTextHTML =  {<Fragment> Få et <em>gavekort</em> på 1.000 kr. </Fragment>}
                            paragraphText="Vi vil gerne byde dig ordentligt velkommen til Privatsikring. Flytter du mindst tre forsikringer til Privatsikring, får du et gavekort på 1.000 kr. til GoGift til at shoppe for. Her kan du vælge mellem mere end 150 forskellige butikker eller oplevelser."
                        />

                        <div>
                            <HeaderAndParagraph
                                color="#FFFFFF"
                                fontSizeP="1.7rem"
                                marginBottomP="0px"
                                marginBottomWrapper="0px"
                                marginBottomWrapperMediaQueriesMedium="0px"
                                fontSizePMediaQueriesMedium="1.3rem"
                                paragraphText="Få et gavekort på 1.000 kr."
                            />
                        </div>
                    </FlexboxWrapper>
                )
            },
            {
                padding: "0 0 52px",
                transition: "fade-up",                             

                image: (
                    <StyledImageContainer
                        marginBottom="24px"
                        marginTopMediaQueriesMedium="88px"
                        marginBottomMediaQueriesMedium="64px"
                        height="172px"
                        maxWidth="720px"
                        maxHeight="275px"
                        imgSrc={landingpageSegments[queryString] && landingpageSegments[queryString].copies.secondImg}
                        
                    />
                ),
                content: (
                    <Fragment>
                        <HeaderAndParagraph

                            marginBottomH1="16px"
                            fontSizeH1MediaQueriesMedium="1.7rem"
                            lineHeightH1MediaQueriesMedium="30px"
                            marginBottomH1MediaQueriesMedium="24px"
                            headerText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.first.header}
                            paragraphText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.first.paragraph}
                        />
                        <IconTextLeftToRight 
                            content={
                                landingpageSegments[queryString] ? landingpageSegments[queryString].copies.first.ul : []
                            }
                        />
                    </Fragment>
                )
            },
            handelSegmentation([
                landingpageSegments.bankkundegjensidige.string,
                landingpageSegments.bankkunde.string
            ]) ? {
                padding: 0,
                paddingMediaQueriesMedium: 0
            } :
            {
                maxWidth: "100%",
                paddingMediaQueriesMedium: "90px 0 90px",
                padding: "25px 2px 2px",
                transition: "fade-up",
                backgroundColor: "#4F525D",
                marginBottomWrapper: "56px",
                content: (
                    <Fragment>
                        <HeaderAndParagraph
                            color = "#FFFFFF"
                            fontSizeH1="1.5rem"
                            lineHeightH1="24px"
                            maxWidth={"335px"}
                            maxWidthMediaQueriesMedium="100%"
                            marginBottomWrapperMediaQueriesMedium="24px"
                            headerTextHTML =  {<Fragment> {landingpageSegments[queryString] && landingpageSegments[queryString].copies.second.header} </Fragment>}

                            paragraphText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.second.paragraph}
                           
                            
                        />

                        <TabsWrapper >
                            <Tabs
                                tabItems={[
                                    {
                                        description: "Fordele til husejere",
                                        isOpen: true,
                                        content: (
                                            <IconTextLeftToRight

                                                widthIcon="22px"
                                                heightIcon="22px"
                                                content={
                                                    landingpageSegments[queryString] ? landingpageSegments[queryString].copies.second.accordion.husejere : []
                                                }
                                            />
                                        )
                                    },
                                    {
                                        description: "Fordele til lejlighedsejere",
                                        isOpen: false,
                                        content: (
                                            <IconTextLeftToRight

                                                widthIcon="22px"
                                                heightIcon="22px"
                                                content={
                                                    landingpageSegments[queryString] ? landingpageSegments[queryString].copies.second.accordion.lejlighedsejere : []
                                                }
                                            />

                                        )

                                    }
                                ]}
                            />
                        </TabsWrapper>
                    </Fragment>
                )
            },
            {
                padding: "0 0 20px",
                transition: "fade-up",                             
                content: (
                    <Fragment>
                        <HeaderAndParagraph
                            fontSizeH1MediaQueriesMedium="1.7rem"
                            lineHeightH1MediaQueriesMedium="44px"
                            marginBottomWrapper="32px"
                            headerText={landingpageSegments[queryString] && landingpageSegments[queryString].copies.third.header}
                        />
                        <IconTextLeftToRight 
                            content={
                                landingpageSegments[queryString] ? landingpageSegments[queryString].copies.third.ul : []
                            }
                        />
                    </Fragment>
                )
            },
            {
                maxWidthMediaQueriesMedium:"100%",
                padding: "46px 0 100px",

                // --- TRUST PILOT --- //
                content: (
                    <TrustPilotWidgets/>
                )
            },
            {
                padding: "75px 0 56px",
                backgroundColor: "#FFFFFF",
                content: (
                    <Fragment>
                        <Quotes
                            data-aos = "fade-up"                                                         
                            maxWidthWrapperMediaQueriesMedium="560px"
                            marginBottomWrapper="64px"
                            marginBottomWrapperMediaQueriesMedium="86px"
                            content={[
                                {
                                    paragraphText: "Vi har valgt Privatsikring som vores nye forsikringspartner. Nykredit ved alt om bank. Privatsikring kender alt til forsikring. Og vi tror på, at når vi går sammen, kan vi give dig tryghed undervejs. I gode og knap så gode tider.",
                                    author: 'Tonny Thierry Andersen',
                                    from: 'Koncerndirektør Nykredit'
                                }
                            ]}
                        />
                        <FlexboxWrapper
                            data-aos = "fade-up"                             
                            justifyContent="space-between"
                        >
                            <FlexboxWrapper
                                flexDirection='column'
                                justifyContent="space-between"
                                width='335px'
                            >
                                <HeaderAndParagraph
                                    marginBottomWrapper="24px"
                                    marginBottomWrapperMediaQueriesMedium="24px"
                                    fontSizeH1="1.17rem"
                                    fontSizeH1MediaQueriesMedium="0.7rem"
                                    fontWeightH1="500"
                                    lineHeightH1="22px"
                                    lineHeightH1MediaQueriesMedium="22px"
                                    marginBottomH1="0"
                                    fontSizePMediaQueriesMedium="0.7rem"
                                    lineHeightP="22px"
                                    headerText="Book onlinemøde"
                                    paragraphText="Hold møde med en forsikringsrådgiver og få sammensat dine forsikringer, så de matcher dine behov."
                                />

                            </FlexboxWrapper>
                            <ButtonOrange
                                    to={routeConstants.ContactModal}
                                    reduxNextPage={routeConstants.BookMeetingModal}
                                    marginBottom="48px"
                                    iconLeft={`${nykreditIcons}#Book_white`}
                                    text="Book møde"
                            />


                        </FlexboxWrapper>
                    </Fragment>
                )
            },
            {
                backgroundColor: "#4F525D",
                maxWidthMediaQueriesMedium:"1080px",
                padding: "46px 0 91px",
                content: (
                    <Footer 
                        content={[
                            {
                                marginBottom: '22px',
                                text: 'All rights reserved © Forsikringsselskabet Privatsikring A/S 2021'
                            },
                            {
                                marginBottom: '22px',
                                text: ['Forsikringsselskabet Privatsikring A/S, Gammel Kongevej 60, DK-1790 København V, privatsikring@privatsikring.dk,', <br key="0" />, 'tlf.: 33 55 26 93 - CVR nr.: 25071409']
                            },
                            {
                                fontSize: "12px",
                                color: "#d6d3d3",
                                text: ['This site is protected by reCAPTCHA and the Google ', <a key="2" href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a>,
                                " and ", <a key="3" href="https://policies.google.com/terms" target="_blank">Terms of Service</a>, " apply."]    
                            }
                        ]}
                    />
                )
            }

        ]

        return components.map((component, index) => {
            return (
                <BackgroundColorContainer
                    isMediaQuery={component.isMediaQuery}
                    key={index}
                    backgroundColor={component.backgroundColor}
                    padding={component.padding}
                    paddingMediaQueriesMedium={component.paddingMediaQueriesMedium}
                    marginTopWrapper={component.marginTopWrapper}
                    marginTopWrapperMediaQueriesMedium={component.marginTopWrapperMediaQueriesMedium}
                    marginLeft={component.marginLeft}
                    marginRight={component.marginRight}
                    height={component.height}
                    width={component.width}
                    maxWidth={component.maxWidth}
                    maxWidthMediaQueriesMedium={component.maxWidthMediaQueriesMedium}
                    maxWidthMediaQueriesLarge={component.maxWidthMediaQueriesLarge}
                    image={component.image}
                    edit={component.edit}
                    marginBottomWrapper = {component.marginBottomWrapper}

                    data-aos = {component.transition} 
                    ClassName ="aos-init aos-animate" 


                >
                    {component.content}
                </BackgroundColorContainer>
            )
        })
    }


    return (
        <Fragment>

            {renderBackgroundColorContainer()}

        </Fragment>
    )
}

export default LandingPage;


